###
  Плавный скролл к элементу
###

class INTENT.utils.Forms

  @ATTR_ACTIONS: "data-form-actions"
  @ATTR_FORM: "data-form-handler"

  @CLASS_SUBMIT_BUTTON: "submit-button"
  @CLASS_REMOVE_ON_DISABLED: "remove-on-disabled"

  @get_actions: ->
    unless @form_actions
      @form_actions = $ "[#{@ATTR_ACTIONS}]"

    return @form_actions

  @get_form: ->
    unless @form
      @form = $ "form[#{@ATTR_FORM}]"

    return @form

  @get_submit_buttons_collection: ->
    @get_actions().find ".#{@CLASS_SUBMIT_BUTTON}"

  @action_buttons_handler: ->
    @get_submit_buttons_collection().each (key, item) ->
      $(item).click (e) ->
        $(e.target)
        .blur()
        .addClass 'disabled'
        .showLoader()

  @disable_submit_buttons_loader: () ->
    @get_submit_buttons_collection().each (key, item) =>
      $(item).hideLoader('disabled')

  @disable_submit_buttons: () ->
    @get_submit_buttons_collection().attr 'disabled', 'disabled'

  @enable_submit_buttons: () ->
    @get_submit_buttons_collection().removeAttr 'disabled'

  @update_codemirror_state: (state = 'readOnly', mode = true) ->
    for cm_key, cm_value of codemirror_instances
      cm_value.setOption state, mode

  @remove_with_class: ->
    $(".#{@CLASS_REMOVE_ON_DISABLED}").remove()

  @update_state_form: ->
    form = @get_form()
    collections = form.find ":input, [data-widget-tree-control]"
    state = form.attr @ATTR_FORM

    unless state then return false

    @remove_with_class()
    @update_codemirror_state()

    switchers = $ 'input[type="checkbox"].on-off'

    if state == 'disabled'
      switchers.bootstrapSwitch 'toggleDisabled'
      collections.attr 'disabled', 'disabled'
      collections.filter('[data-widget-tree-control]').addClass 'disabled'

    if state == 'read-only'
      switchers.bootstrapSwitch 'toggleReadonly'
      collections.attr 'readonly', 'readonly'
      collections.filter('[data-widget-tree-control]').addClass 'readonly'
